import classNames from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

export const CloseButton: FC<{ className?: string; onClosed: () => void }> = ({ className, onClosed }) => {
  const { formatMessage } = useIntl();
  return (
    <button
      type="button"
      className={classNames('btn btn-xl btn-flat-secondary', className)}
      aria-label="Close"
      onClick={onClosed}
      data-e2e="close-tile"
      data-tour="quoteDashboard.tile.delete"
      title={formatMessage({ id: 'close' })}
    >
      <i className="icon">close</i>
    </button>
  );
};
